import script from "./ProgramModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgramModal.vue?vue&type=script&setup=true&lang=js"

import "./ProgramModal.vue?vue&type=style&index=0&id=6c66797a&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/core_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c66797a"]])

export default __exports__